import * as types from 'constants/actionTypes';
import * as Rx from 'rxjs';
const { Observable } = Rx;
const { of, ajax } = Observable;
import * as actions from 'actions/provisioningActions';
const apiUrls = require('constants/apiUrls');
import { wowCustomHeader } from '../utils/wowCustomHeadersUtils';
import { getAccessTokenFromState } from 'utils/userManager';

export const indirect = {
  call: (fn, ...args) => fn(...args)
};

export const api = {
  getActiveServices: (accountNumber, store) => {

    const billingSystem = 'Icoms';

    const state = store.getState();
    const accessToken = getAccessTokenFromState(state);

    const wowHeaders = wowCustomHeader(state);

    const url = apiUrls.ACTIVE_SERVICES_URL;

    return ajax({
      url: `${url}?billingSystem=${billingSystem}&accountNo=${accountNumber}`,
      method: 'get',
      responseType: 'json',
      crossDomain: true,
      timeout: apiUrls.API_TIMEOUT,
      headers: {
        ...wowHeaders,
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': 'Bearer ' + accessToken
      }
    });
  }
};

export const getActiveServicesEpic = (action$, store, call = indirect.call) => action$
  .ofType(types.ACTIVE_SERVICES_REQUEST_STARTED)
  .mergeMap(action => call(api.getActiveServices, action.accountNumber, store).map(payload => {
    return (actions.getActiveServicesFinished(payload.response, action.accountNumber));
  })
    .catch(error => of(actions.getActiveServicesFailed(error, action.accountNumber))));



// WEBPACK FOOTER //
// ./src/epics/careAccountEpics.js